var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var SECONDS_OUT = 0.3;
export var SECONDS_IN = 0.7;
export var flyoutTransitionIn = {
    duration: SECONDS_IN,
    type: 'tween',
    ease: [0.5, 0, 0, 1],
    precision: 0.01
};
export var flyoutTransitionOut = {
    duration: SECONDS_OUT,
    type: 'tween',
    ease: [0.5, 0, 0, 1],
    precision: 0.01
};
export var containerVariants = {
    initial: {
        x: '100%',
        transition: __assign({}, flyoutTransitionOut)
    },
    open: {
        x: 0,
        transition: __assign({}, flyoutTransitionIn)
    },
    closed: {
        x: '100%',
        transition: __assign({}, flyoutTransitionOut)
    }
};
export var homeMenuVariants = function (open) {
    return {
        animate: {
            x: 0,
            transition: open ? __assign({}, flyoutTransitionOut) : __assign({}, flyoutTransitionIn)
        },
        exit: {
            x: '-100%',
            transition: __assign({}, flyoutTransitionOut)
        }
    };
};
export var subMenuVariants = function (open) {
    return {
        animate: {
            x: 0,
            transition: __assign({}, flyoutTransitionOut)
        },
        exit: open
            ? {
                x: '100%',
                transition: __assign({}, flyoutTransitionOut)
            }
            : {}
    };
};
